import classNames from 'classnames'

import * as styles from '../../TableComponent/TableComponent.module.css'

export function useTableRowModClassName({
  activeClassName = styles.active,
  className,
  dragHoverClassName = styles.dragHover,
  isActive,
  isDragHover,
  isSelected,
  selectedClassName = styles.selected,
}) {
  return classNames(className, {
    [activeClassName]: isActive,
    [dragHoverClassName]: isDragHover,
    [selectedClassName]: isSelected,
  })
}
